// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CREATE_KHO_HANG, GET_DANH_SACH_KHO, GET_DANH_SACH_KHO_DONE, UPDATE_DEFAULT_KHO_HANG, UPDATE_KHO_HANG, UPDATE_STATUS_KHO_HANG } from "./constant";

export const GetDanhSachKhoAction = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_DANH_SACH_KHO,
    payload,
    callback
  };
};

export const GetDanhSachKhoActionDone = (data: any) => ({
  type: GET_DANH_SACH_KHO_DONE,
  payload: data
})

export const CreateKhoHang = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: CREATE_KHO_HANG,
    payload: payload,
    callback
  };
};

export const UpdateStatusKhoHang = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: UPDATE_STATUS_KHO_HANG,
    payload: payload,
    callback
  };
};

export const UpdateDefaultKho = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: UPDATE_DEFAULT_KHO_HANG,
    payload: payload,
    callback
  };
};

export const UpdateKhoHang = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: UPDATE_KHO_HANG,
    payload: payload,
    callback
  };
};
